import { isAfter, isBefore } from 'date-fns';
export function isInRange(date, _ref) {
  let {
    endDate,
    startDate
  } = _ref;
  return !isAfter(date, endDate) && !isBefore(date, startDate);
}